import { Phone, MessageCircle, CalendarCheck, ShoppingBag } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { trackCta } from "@/lib/tracking/tracker";

const VARIANTS = {
  primary: "bg-forest text-bone hover:bg-forest-deep",
  gold: "bg-gold text-forest hover:brightness-105",
  outline: "border border-forest/25 bg-white text-forest hover:border-forest",
  light: "border border-white/25 bg-white/5 text-bone hover:bg-white/15",
  whatsapp: "bg-[#1FAF55] text-white hover:bg-[#189A49]",
};
const ICONS = { consult: CalendarCheck, order: ShoppingBag, call: Phone, whatsapp: MessageCircle };

// Every CTA on the page goes through this component so each click is tracked with a unique cta_name.
export const Cta = ({ kind, name, position, variant = "primary", size = "lg", label, className = "", icon = true, labelClass = "" }) => {
  const { contacts, content, openModal } = useSite();
  const text = label || content.cta_text?.[kind] || kind;
  const Icon = ICONS[kind];
  const sizing = { lg: "min-h-[56px] px-6 text-base sm:text-[17px]", md: "min-h-[52px] px-4 text-base sm:px-3 sm:text-[15px] whitespace-nowrap", sm: "min-h-[44px] px-4 text-sm", bar: "min-h-[52px] px-3 text-sm whitespace-nowrap" }[size];
  const cls = `group inline-flex items-center justify-center gap-2 rounded-full font-extrabold uppercase tracking-[0.02em] transition-[background-color,transform,filter,border-color] duration-300 active:scale-[0.98] hover:-translate-y-0.5 ${sizing} ${VARIANTS[variant]} ${className}`;
  const onClick = () => {
    trackCta(name, position, kind);
    if (kind === "consult") openModal("lead", name, position);
    if (kind === "order") openModal("order", name, position);
  };
  const inner = (
    <>
      {icon && Icon && <Icon className="h-[18px] w-[18px] transition-transform duration-300 group-hover:rotate-[-8deg]" aria-hidden />}
      <span className={labelClass}>{text}</span>
    </>
  );
  if (kind === "call") {
    return <a href={`tel:${contacts.phone}`} onClick={onClick} className={cls} data-testid={`cta-${name}`} data-cta={name}>{inner}</a>;
  }
  if (kind === "whatsapp") {
    const msg = encodeURIComponent(content.brand?.whatsapp_message || "");
    return (
      <a href={`https://wa.me/${contacts.whatsapp}${msg ? `?text=${msg}` : ""}`} target="_blank" rel="noopener noreferrer"
        onClick={onClick} className={cls} data-testid={`cta-${name}`} data-cta={name}>{inner}</a>
    );
  }
  return <button type="button" onClick={onClick} className={cls} data-testid={`cta-${name}`} data-cta={name}>{inner}</button>;
};
